import React from 'react';

const Services = () => {
    return (
        <div className="NewServices_Container__MqkmW" id="services">
            <div className="NewServices_headingCont__TjVl0">
                <h2 className="NewServices_heading__XutKv">Services</h2>
                <div className="NewServices_underline__j_UyP"></div>
            </div>
            <p className="NewServices_subHead__NjkSp">We provide Artificial Intelligence Services</p>
            <div className="NewServices_cardCont__m0LU2">
                <div style={{ position: "relative" }} className="NewServices_cardBox__c99Fz">
                    <div className="NewServices_green__SlGLa"></div>
                    <div className="NewServiceCard_headerCard__438DV">
                        <div>
                            <div className="NewServiceCard_headingCont__QkfmB">
                                <div>
                                    <span className="NewServiceCard_number__FPZAO">0</span>
                                    <span className="NewServiceCard_number__FPZAO">1</span>
                                </div>
                                <div style={{ border: "none", color: "#01C99B" }} className="NewServiceCard_cardHead__JPzMC">Biometrics</div>
                            </div>
                            <h5 style={{ border: "none" }} className="NewServiceCard_cardBody__d0fwE">Academia-backed &amp; In-house
                                researched State-of-the-Art Face, Fingerprint, and Iris Recognition SDKs. Enable real-time
                                automated Biometric applications on edge devices even without an active internet connection.
                            </h5>
                        </div>
                    </div>
                </div>
                <div style={{ position: "relative" }} className="NewServices_cardBox__c99Fz">
                    <div className="NewServices_blue__0QNKZ"></div>
                    <div className="NewServiceCard_headerCard__438DV">
                        <div>
                            <div className="NewServiceCard_headingCont__QkfmB">
                                <div>
                                    <span className="NewServiceCard_number__FPZAO">0</span>
                                    <span className="NewServiceCard_number__FPZAO">2</span>
                                </div>
                                <div style={{ border: "none", color: "#3FBDF1" }} className="NewServiceCard_cardHead__JPzMC">Image Analysis</div>
                            </div>
                            <h5 style={{ border: "none" }} className="NewServiceCard_cardBody__d0fwE">Outsource the overly complex
                                image analysis work to our intelligent machines that adaptively learn, so you can focus on
                                making the best decisions for your business.</h5>
                        </div>
                    </div>
                </div>
                <div style={{ position: "relative" }} className="NewServices_cardBox__c99Fz">
                    <div className="NewServices_red__VudPn"></div>
                    <div className="NewServiceCard_headerCard__438DV">
                        <div>
                            <div className="NewServiceCard_headingCont__QkfmB">
                                <div>
                                    <span className="NewServiceCard_number__FPZAO">0</span>
                                    <span className="NewServiceCard_number__FPZAO">3</span>
                                </div>
                                <div style={{ border: "none", color: "#FF605F" }} className="NewServiceCard_cardHead__JPzMC">Cross-Media Translation</div>
                            </div>
                            <h5 style={{ border: "none" }} className="NewServiceCard_cardBody__d0fwE">Will something like Siri or Alexa
                                enhance your business? We can deliver text-to-speech, text-to-image, speech-to-text,
                                speech-to-image, image-to-text, and image-to-speech solutions for maximum
                                convenience.</h5>
                        </div>
                    </div>
                </div>
                <div style={{ position: "relative" }} className="NewServices_cardBox__c99Fz">
                    <div className="NewServices_yellow__xBHmm"></div>
                    <div className="NewServiceCard_headerCard__438DV">
                        <div>
                            <div className="NewServiceCard_headingCont__QkfmB">
                                <div>
                                    <span className="NewServiceCard_number__FPZAO">0</span>
                                    <span className="NewServiceCard_number__FPZAO">4</span>
                                </div>
                                <div style={{ border: "none", color: "#FF9F31" }} className="NewServiceCard_cardHead__JPzMC">3D Modelling
                                    and Design.</div>
                            </div>
                            <h5 style={{ border: "none" }} className="NewServiceCard_cardBody__d0fwE">We offer services for automated
                                generation of 3D assets with realistic shapes and textures. We animate the 3D models with
                                voice and videos with an aim to retarget voice and/or expressions with pose from a single
                                Image/video.</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;
